<div class="row" tourAnchor="asset.dashboard.summary">
  <div class="col-12">
    @if (assetData()) {
      <div class="asset-summary widget-card card bg-white mx-0">
        @if (!showingOnPositionDashboard()) {
          <div class="row headersection grid grid-cols-1 gap-y-5 lg:grid-cols-12">
            <div class="col"
              [ngClass]="showGallery() && showingOnPositionDashboard() ? 'lg:col-span-7' : showGallery() ? 'lg:col-span-5' : 'lg:col-span-12'">
              @if (showLogo()) {
                <div class="logo">
                  <img src="{{logo()}}" alt="Asset Logo" data-cy="assetLogo">
                </div>
              }
              <div>
                <h4 class="summary-text">Summary</h4>
              </div>
              <div class="summary-desc">
                @if (showSummary()) {
                  <div>
                    <div [innerHTML]="(summary() ?? '') | safeHtml" #summaryElement class="line-clamp text-md md:text-lg"
                      data-cy="assetSummary"
                      [ngClass]="{'block-ellipsis-with-logo': showLogo(), 'block-ellipsis-without-logo' : !showLogo() }">
                    </div>
                    @if (showMoreButton()) {
                      <div>
                        <a href="javaScript:;" (click)="openModal()" data-cy="viewMoreButton"
                        class="view-more-btn">View More</a>
                      </div>
                    }
                  </div>
                }
                @else {
                  <div>
                    <div class="no-summary" data-cy="noSummaryText">No Asset Summary Available</div>
                  </div>
                }
              </div>
            </div>
            @if (showGallery()) {
              <div [ngClass]="showingOnPositionDashboard() ? 'lg:col-span-5' : 'lg:col-span-7'"
                class="px-4 lg:col-span-7">
                <app-image-carousel [slidingImgs]="slidingImgs()" data-cy="assetImages"></app-image-carousel>
              </div>
            }
          </div>
        }
        <div class="lg:grid lg:grid-cols-3 gap-2">
          <div [ngClass]="showGallery() && showingOnPositionDashboard() ? 'col-span-2' : 'col-span-3'">
            @if (showingOnPositionDashboard()) {
              <span class="text-md md:text-2xl font-bold">Asset Summary</span>
            }
            <!-- Dynamic Asset Fields Rendering -->
            <div class="data-items row grid gap-x-3 grid-cols-2 h-full"
              [ngClass]="{
                'md:grid-cols-5': assetType() === 'Infrastructure',
                'md:grid-cols-4': assetType() === 'Real Estate' || assetType() === 'Portfolio Company'
              }"
              [attr.data-cy]="containerDataCy()">

              @for (field of assetFields(); track field.label) {
                <div class="col">
                  <div class="value text-md md:text-lg" 
                    [attr.data-cy]="field.dataCy">
                    @switch (field.type) {
                      @case ('text') {
                        {{ (field.value | standardStringFormat) || 'N/A'}}
                      }
                      @case ('date') {
                        {{ (field.value | dateFormat:'MM/dd/yyyy') || 'N/A' }}
                      }
                      @case ('asIs') {
                        {{ field.value || 'N/A' }}
                      }
                    }
                  </div>
                  <div class="title text-md md:text-lg" >{{ field.label }}</div>
                </div>
              }
            </div>
          </div>
          @if (showGallery() && showingOnPositionDashboard()) {
            <div>
              <app-image-carousel [slidingImgs]="slidingImgs()" alt="Asset Images" data-cy="assetImages"></app-image-carousel>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>